import { render, staticRenderFns } from "./ShowCorrectOptionSticker.vue?vue&type=template&id=1c905792&scoped=true&"
import script from "./ShowCorrectOptionSticker.vue?vue&type=script&lang=js&"
export * from "./ShowCorrectOptionSticker.vue?vue&type=script&lang=js&"
import style0 from "./ShowCorrectOptionSticker.vue?vue&type=style&index=0&id=1c905792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c905792",
  null
  
)

export default component.exports